<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span>

    <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="!prevNext?.prev || isBusy" (click)="gotoPrevTrans()">Previous</button>
    <button mat-raised-button color="primary" [disabled]="!prevNext?.next || isBusy" (click)="gotoNextTrans()">Next</button>

  </div>

</div>


<mat-card class="content-card" *ngIf="transaction">
  <mat-card-header>
    <mat-card-title>
      <h5><span (click)="returnBack()" style="cursor: pointer">◀️</span> Load Account Transaction - {{ transaction.statementDate | date: "dd.MM.yyyy HH:mm" }}</h5>

    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div *ngIf="transaction">
      <div style="max-width: 680px;">
        <div class="list-item" fxLayout="row" *ngFor="let field of fields">

          <label fxFlex="35" class="secondary">{{ field.header }}</label>

          <label fxFlex="65"
                 *ngIf="!(field.cell(transaction).startsWith('&lt;a') || field.cell(transaction).startsWith('&lt;i'))">
            {{ field.cell(transaction) }}

            <ng-container *ngIf="field.header === 'Reference' && transaction.reference">
              <button mat-flat-button (click)="searchTransactionReference()"><mat-icon>search</mat-icon></button>
            </ng-container>
            <ng-container *ngIf="field.header === 'Description' && transaction.description">
              <button mat-flat-button (click)="searchTransactionDescription()"><mat-icon>search</mat-icon></button>
            </ng-container>

            <ng-container *ngIf="field.header === 'Counter Account Name' && transaction.counterAccountName">
              <button mat-flat-button (click)="searchTransactionCounterAccountName()"><mat-icon>search</mat-icon></button>
            </ng-container>

          </label>

        </div>
      </div>


    </div>

    <div *ngIf="transaction.willRefund"  style="margin-top: 20px;">
      <span style="color: red; font-weight: bold">
        <mat-icon>money_off</mat-icon> This transaction will be refunded.
      </span>
    </div>

    <div *ngIf="transaction.cardFound == null && !transaction.willRefund && currentUserIsAdmin()" style="margin-top: 20px;">
      <button [disabled]="isBusy" mat-raised-button color="accent" (click)="refundTransaction()">
        <mat-icon>money_off</mat-icon> Refund transaction
      </button>
    </div>


    <!--<div *ngIf="transaction && (!transaction.reference && !transaction.description) && !transaction.willRefund" style="margin-top: 20px;">
      <span style="color: red; font-weight: bold">
        <mat-icon>highlight_off</mat-icon> This transaction cannot be linked yet. Reference and Description is missing. Import Trustpay Statement file to fill them.
      </span>
    </div>-->

    <div *ngIf="transaction && !transaction.willRefund">
      <div fxLayout="row" style="margin-top: 15px;">
        <div fxFlex="48">
          <h4>Card</h4>

          <div *ngIf="transaction && transaction.cardFound == null">
            <mat-form-field>
              <input matInput type="text" [(ngModel)]="cardSearch1" (keydown.enter)="onSearchCard1()"/>
            </mat-form-field>
            <button mat-icon-button (click)="onSearchCard1()" [disabled]="cardSearch1 == null || (cardSearch1 != null && cardSearch1.length <= 3)">
              <mat-icon>search</mat-icon>
            </button>
            <div [hidden]="!cardSearch1Loading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="cards1Found" style="height: 250px; overflow: auto">
              <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-right: 15px;">
                <tr>
                  <th class="" style="text-align: left; width: 150px;"><label></label></th>
                  <th class="" style="text-align: left; width: 120px;"><label>Token</label></th>
                  <th style="text-align: left; width: 200px;"><label>Customer</label></th>
                  <th style="text-align: left; width: 60px;"><label>Expiry</label></th>
                  <th style="text-align: left; width: 140px;"><label>Status</label></th>

                </tr>
                <tr *ngFor="let crd of cards1Found" [class]="'cardfound-row cardfound-' + crd.status">
                  <td>
                    <!--<mat-checkbox [(ngModel)]="inv1MarkedAsPaid"> mark as paid</mat-checkbox>&nbsp;&nbsp;-->
                    <button [disabled]="isBusy" mat-raised-button color="primary" (click)="linkCard(crd.id)">
                      <mat-icon>link</mat-icon>
                    </button>
                  </td>
                  <td><a [routerLink]="'/cards/' + crd.id">{{ crd.publicToken }}</a><br /><span *ngIf="crd.archived"><span style="color: red;">(archived)</span></span></td>
                  <td>
                    <div *ngIf="crd.customer">
                      {{ crd.customer.firstName }} {{ crd.customer.lastName }}

                    </div>
                  </td>
                  <td>{{ crd.expireDateString }}</td>
                  <td>{{ crd.statusName }}</td>
                </tr>
              </table>

            </div>
          </div>
          <div *ngIf="transaction && transaction.cardFound != null">
            <button style="margin-right: 15px;" mat-raised-button color="warn" [disabled]="isBusy" (click)="unlinkCard(transaction.cardFound.id)"><mat-icon>delete</mat-icon></button>
            <a [routerLink]="'/cards/' + transaction.cardFound.id"> {{ transaction.cardFound.token }}</a>
            <span *ngIf="transaction && transaction.cardFound.archived">
              - <span style="color: red;">archived</span>
            </span>
            -
            {{ transaction.cardFound.productName }}, {{ transaction.cardFound.cardTypeName }} {{ transaction.cardFound.cardName }}, {{transaction.cardFound.statusName}}, EXP {{ transaction.cardFound.expireDate | date:"MM/yy" }}

          </div>

        </div>

      </div>
    </div>

  </mat-card-content>

  <mat-card-actions align="start">


  </mat-card-actions>

</mat-card>
